module.exports = __webpack_public_path__ + "img/dashboard.ba7ddfd1.svg";